import { createSlice } from '@reduxjs/toolkit'

const modalSlice = createSlice({
  name: 'app',
  initialState: {
    actionModalProps: {
      header: '',
      content: '',
      key: 0,
      open: false,
      type: '',
      tab: ''
    },
    changelogModal: {
      open: false,
      action: '',
      date: '',
      contentState: { blocks: [], entityMap: {} }
    }
  },
  reducers: {
    setActionModal: (state, action) => void (state.actionModalProps = action.payload),
    setChangelogModal: (state, action) => void (state.changelogModal = action.payload),
  }
})

export const { setActionModal, setChangelogModal } = modalSlice.actions

export default modalSlice.reducer